import moment, { Moment } from 'moment'
import {
  AccountInfoDto,
  BlockOffEmployee,
  BOOKING_TYPE,
  ServiceCategoryDto,
  TaskDto,
  VendorInfoDto
} from '../../../../../definition'
import { ScheduleCalendarConfigurationType } from '../../../../../definition/time-slot.dto'
import { getDay, getDayNumberFromString, getWeekDayLabel } from '../../../../../utils/datetime'
import defaultAvatar from './../../../../../styles/images/default-avatar.jpg'
import getTaskStatus from '../../../../components/task-status.component'
import { NavLink } from 'react-router-dom'
import ClockIcon from './../../../../../styles/images/clock.png'
import { checkIsBlockWorkDay } from '../../../../../utils/booking-util'
import { appEventEmitter } from '../../../../../initialization'
import { ModalNode } from '../../../../components/modal.component'
import { APP_EVENTS } from '../../../../../constants'
import { BlockOffItemModal } from '../block-off-item'
import { Tooltip } from 'antd'
import { AllTaskInDayModal } from './all-task-in-day'

const MAX_DISPLAY_TASKS = 4

type ScheduleCalendarWeeklyPropType = {
  startDate: Moment
  tasks: TaskDto[]
  configuration?: ScheduleCalendarConfigurationType
  weekStart?: string
  vendors: VendorInfoDto[]
  technicians: AccountInfoDto[]
  mainCategories: ServiceCategoryDto[]
  selectedMainCategoryId: string[]
  selectedVendorId: string[]
  refreshSchedule: () => void
}

const todayDay = new Date().getDay() === 0 ? 7 : new Date().getDay()
const DEFAULT_WEEKSTART = moment().startOf('week').toISOString()

const ScheduleCalendarWeekly = (props: ScheduleCalendarWeeklyPropType) => {
  const groupByTech = Object.groupBy(props.tasks, ({ assignee }) => assignee?.profile?.name || 'unassign')

  const techDontHaveTask = props.technicians
    .filter((tech) => !groupByTech[tech.profile?.name as string])
    .filter((tech) => {
      if (props.selectedVendorId.length === 0) {
        return true
      } else {
        if (tech?.companyId && props.selectedVendorId.includes(tech?.companyId)) {
          return true
        } else return false
      }
    })

  const onSeeBlockTime = (block: BlockOffEmployee, date: string) => {
    appEventEmitter.emit<ModalNode>(APP_EVENTS.app_modal, {
      input: {
        block: block,
        technicians: props.technicians,
        date: date,
        refreshSchedule: props.refreshSchedule
      },
      status: true,
      node: BlockOffItemModal,
      title: 'Blocked Time',
      onClose: () => {},
      onDone: () => {}
    })
  }

  const onSeeAllTask = (key: string, tasksInDay: TaskDto[], date: string, mainCategory?: string) => {
    appEventEmitter.emit<ModalNode>(APP_EVENTS.app_modal, {
      input: {
        tasks: tasksInDay,
        mainCategory: mainCategory
      },
      status: true,
      node: AllTaskInDayModal,
      title: `Time Block - ${key}, ${date} `,
      onClose: () => {},
      onDone: () => {}
    })
  }

  return (
    <div className='schedule-wrapper-weekly'>
      <div className='table'>
        {[999, 7, 1, 2, 3, 4, 5, 6].map((dayIndex) => {
          const isTodayDay = todayDay === dayIndex
          const columnDate = moment(props.weekStart).add(dayIndex, 'day').format('YYYY-MM-DD')
          if (dayIndex === 999) {
            return (
              <div className='column head sticky'>
                <div className='heading '>
                  <img src={ClockIcon} alt='clock' width={24} />
                </div>
                {Object.keys(groupByTech)
                  .filter((key) => key !== 'unassign')
                  .map((key) => {
                    const task = props.tasks.find((task) => task.assignee?.profile?.name === key)
                    const mainCategory = props.mainCategories.find(
                      (cat) => task?.company?.mainCategoryId === cat.id
                    )?.name

                    const info = (
                      <div className='tech-info-title'>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>{key}</div>
                        <div style={{ fontWeight: 400, fontSize: 12 }}>{mainCategory}</div>
                        <div style={{ fontWeight: 400, fontSize: 12 }}>{task?.company?.name}</div>
                      </div>
                    )

                    return (
                      <Tooltip placement='right' title={info}>
                        <div className='side-technician-item tech-info' key={key}>
                          <img src={task?.assignee?.profile?.avatarUrl || defaultAvatar} alt='tech' />
                          {info}
                        </div>
                      </Tooltip>
                    )
                  })
                  .concat(
                    techDontHaveTask
                      .filter((tech) => props.vendors.find((vendor) => vendor.id === tech.companyId))
                      .filter((tech) => {
                        if (props.selectedMainCategoryId.length === 0) {
                          return true
                        }
                        const vendor = props.vendors.find((vendor) => vendor.id === tech.companyId)
                        return vendor && props.selectedMainCategoryId.includes(vendor?.mainCategoryId)
                      })
                      .map((tech) => {
                        const vendor = props.vendors.find((vendor) => vendor.id === tech.companyId)
                        const info = (
                          <div className='tech-info-title'>
                            <div style={{ fontWeight: 600, fontSize: 14 }}>{tech.profile?.name}</div>
                            <div style={{ fontWeight: 400, fontSize: 12 }}>{vendor?.mainCategory?.name}</div>
                            <div style={{ fontWeight: 400, fontSize: 12 }}>{vendor?.name}</div>
                          </div>
                        )
                        return (
                          <Tooltip placement='right' title={info}>
                            <div className='side-technician-item tech-info' key={tech.name}>
                              <img src={tech?.profile?.avatarUrl || defaultAvatar} alt='tech' />
                              {info}
                            </div>
                          </Tooltip>
                        )
                      })
                  )}
              </div>
            )
          }
          return (
            <div key={dayIndex} className={`column  ${isTodayDay ? 'col-highlight' : ''}`}>
              <span className='heading '>
                <span>
                  {getDay(dayIndex)?.toUpperCase()} {getWeekDayLabel(props.weekStart || DEFAULT_WEEKSTART)[dayIndex]}
                </span>
              </span>
              {Object.entries(groupByTech)
                .filter(([key]) => key !== 'unassign')
                .map(([key, tasks]) => {
                  const tasksInDay = tasks?.filter((task) => {
                    const day =
                      moment(task.timeSlotBeginAt).startOf('day').get('day') === 0
                        ? 7
                        : moment(task.timeSlotBeginAt).startOf('day').get('day')
                    return day === dayIndex
                  })
                  const task = props.tasks.find((task) => task.assignee?.profile?.name === key)

                  const vendor = props.vendors.find((vendor) => vendor.id === task?.companyId)
                  const tech = props.technicians.find((tech) => tech.id === task?.assigneeId)

                  const isRest =
                    vendor?.operatingTime?.find((operation) => getDayNumberFromString(operation.name) === dayIndex)
                      ?.enable === false

                  const { isBlock, block } = checkIsBlockWorkDay(
                    tech?.blockOffEmployees || [],
                    dayIndex,
                    props.weekStart || DEFAULT_WEEKSTART
                  )

                  const taskIndayLength = (tasksInDay || [])?.length

                  return (
                    <div className='side-technician-item' key={key}>
                      {tasksInDay
                        ?.slice(0, MAX_DISPLAY_TASKS)
                        .filter((_, index) => {
                          if (taskIndayLength === MAX_DISPLAY_TASKS && index === MAX_DISPLAY_TASKS - 1) {
                            return true
                          } else if (taskIndayLength > MAX_DISPLAY_TASKS && index >= MAX_DISPLAY_TASKS - 1) {
                            return false
                          } else {
                            return true
                          }
                        })
                        ?.map((task) => {
                          const { cssStatus } = getTaskStatus(task.status)
                          const bookingType = task.booking?.type
                          const bookingLink =
                            bookingType === BOOKING_TYPE.RECURRING ? 'contract-booking' : 'one-time-booking'

                          return (
                            <div key={task.code}>
                              <NavLink
                                to={`/schedule/${bookingLink}?bookingId=${task.bookingId}`}
                                target='_blank'
                                className={`task-item ${cssStatus}`}
                              >
                                <span className='task-item-code' style={{ fontWeight: task.isTbc ? 700 : 'normal' }}>
                                  {task.postalCode}
                                </span>{' '}
                                |{' '}
                                <span className='task-item-timeslot'>
                                  {moment(task?.timeSlotBeginAt).format('HH:mm')}-
                                  {moment(task?.timeSlotEndAt).format('HH:mm')}
                                  {task.isTbc ? '*' : ''}
                                </span>
                              </NavLink>
                            </div>
                          )
                        })}
                      {taskIndayLength > MAX_DISPLAY_TASKS ? (
                        <div
                          onClick={() =>
                            onSeeAllTask(
                              key,
                              tasksInDay || [],
                              moment(task?.timeSlotEndAt).format('DD/MM/YYYY'),
                              vendor?.mainCategory.name
                            )
                          }
                          style={{ fontSize: 12, cursor: 'pointer' }}
                        >
                          + {taskIndayLength - (MAX_DISPLAY_TASKS - 1)} jobs
                        </div>
                      ) : null}
                      {isRest && <div className='rest-block'>Rest day </div>}
                      {isBlock && block && (
                        <div className='rest-block' onClick={() => onSeeBlockTime(block, columnDate)}>
                          {block.reason || 'Time Block'}
                        </div>
                      )}
                    </div>
                  )
                })
                .concat(
                  techDontHaveTask
                    .filter((tech) => props.vendors.find((vendor) => vendor.id === tech.companyId))
                    .filter((tech) => {
                      if (props.selectedMainCategoryId.length === 0) {
                        return true
                      }
                      const vendor = props.vendors.find((vendor) => vendor.id === tech.companyId)
                      return vendor && props.selectedMainCategoryId.includes(vendor?.mainCategoryId)
                    })
                    .map((tech) => {
                      const vendor = props.vendors.find((vendor) => vendor.id === tech.companyId)
                      const isRest =
                        vendor?.operatingTime?.find((operation) => getDayNumberFromString(operation.name) === dayIndex)
                          ?.enable === false

                      const { isBlock, block } = checkIsBlockWorkDay(
                        tech?.blockOffEmployees || [],
                        dayIndex,
                        props.weekStart || DEFAULT_WEEKSTART
                      )
                      return (
                        <div className='side-technician-item' key={tech.id}>
                          {isRest && <div className='rest-block'>Rest day</div>}
                          {isBlock && block && (
                            <div className='rest-block' onClick={() => onSeeBlockTime(block, columnDate)}>
                              {block.reason || 'Time Block'}
                            </div>
                          )}
                        </div>
                      )
                    })
                )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ScheduleCalendarWeekly
